export const colorSchemes = {

    btn:['#BB5555', '#BB7777', '#BB9999', '#BBBBBB', '#BBDDDD', '#BBFFFF']
    //btn:[/*'#55BB55', '#77BB77', */'#99BB99', '#BBBBBB', '#DDBBDD', '#FFBBFF']

   // btn:['#FFBBBB', '#DDBBBB', '#BBBBBB', '#99BBBB', '#77BBBB', '#55BBBB']
}

export const inlBlockStyle = {display: 'inline-block'};




// WEBPACK FOOTER //
// ./js/ColorSchemes.jsx